/// <amd-module name="Artifacts/Root/components/DeleteModal" />
import { CommandPanel } from "Artifacts/Root/components/CommandPanel";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { RootModule } from "Artifacts/Root/redux/Module";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { connect } from "react-redux";

export interface IDeleteModalProps {
  packages?: IPackageVersionIdentity[];
  onDismiss: () => void;
  onDelete: () => void;
}

interface IMapStateToProps {
  componentState: ComponentState;
}

export const DeleteModalId = "DeleteModal";

const DeleteModal: React.FC<IDeleteModalProps & IMapStateToProps> = ({
  packages,
  onDismiss,
  onDelete,
  componentState,
}) => {
  return (
    <CommandPanel
      title={Res.DeletePackageDialogTitle}
      description={Res.DeleteDialog_ConfirmText}
      packages={packages}
      onDismiss={onDismiss}
      onSubmit={onDelete}
      submitButtonComponentState={componentState}
      submitButtonText={Res.DeleteCommand}
      isSubmitButtonDanger={true}
      warningText={Res.DeleteDialog_SevereWarningText}
      warningTextFWLinkId="869883"
    ></CommandPanel>
  );
};

const mapStateToProps = (state: IRootModuleState): IMapStateToProps => {
  const rootState = state.rootState;
  return {
    componentState: rootState.softDeleteCommandState,
  };
};

const ConnectedDeleteModal = connectDynamicModules(connect(mapStateToProps)(DeleteModal), [
  RootModule,
]);

registerModal(DeleteModalId, ConnectedDeleteModal);

export { DeleteModal };
